<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="6" class="pa-0">
          <v-form @submit="forgotPassword">
            <v-card color="blur">
              <v-card-text style="color: #eeeeee" class="text-center">
                <h2 class="ma-0">Forgot password?</h2>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text style="color: #eeeeee" class="text-center">
                <p class="ma-0">Please provide your email.</p>
                We will send you instructions on how to reset your password. If you have not recived them, please check your spam-folder.
              </v-card-text>
              <v-card-text class="pb-0">
                <v-text-field
                    v-model="email"
                    color="success"
                    label="Email"
                    prepend-icon="mdi-email"
                    :error-messages="api_errors['email']"
                    required solo-inverted
                    type="email"
                />
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="success box-shadow" type="submit" block>
                  Let's Go
                </v-btn>
              </v-card-actions>
              <v-card-actions class="justify-center">
                <v-btn text small class="ma-0" color="white" :to="{name: 'Login'}">
                  Back to Sign in
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    email: '',
    api_errors: []
  }),
  methods: {
    forgotPassword (e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/password/forgot', {email: this.email,})
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            localStorage.setItem('tmpEmail', this.email)
            this.$router.push({ name: 'Reset Password' })
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
  },
}
</script>